import $ from 'jquery';
import { InventorySearchEvents } from '@dealersites/inventory/events';

class LocalGarage {
  static init() {
    checkIcon();
    // checkbox change
    $('.comparable-check').on('change', function () {
      comparableCheck();
      comparableFormat();
    });

    // comparable hover
    $('.comparable')
      .on('mouseover', function () {
        const group = $(this).data('comparable');
        $(`.${group}`).each(function () {
          $(this).addClass('hovering');
        });
      })
      .on('mouseout', function () {
        const group = $(this).data('comparable');
        $(`.${group}`).each(function () {
          $(this).removeClass('hovering');
        });
      });

    comparableCheck();
    comparableFormat();
  }

  static has(id) {
    id = parseInt(id);

    if (dsp.garage) {
      return dsp.garage.has(id);
    }

    const garage = JSON.parse(localStorage.getItem('garage') || '[]');
    return garage.includes(id);
  }

  static isEmpty() {
    if (dsp.garage) {
      return dsp.garage.isEmpty();
    }

    const garage = JSON.parse(localStorage.getItem('garage') || '[]');
    return garage.length === 0;
  }

  static empty() {
    if (dsp.garage) {
      dsp.garage.reset();
      return;
    }

    localStorage.removeItem('garage');
    checkIcon();
  }

  static remove(id) {
    id = parseInt(id);

    if (dsp.garage) {
      dsp.garage.remove(id);
      return;
    }

    const jsGarage = JSON.parse(localStorage.getItem('garage') || '[]');
    localStorage.setItem('garage', JSON.stringify(jsGarage.filter((_id) => _id !== id)));
    checkIcon();
  }

  static add(id) {
    id = parseInt(id);

    if (dsp.garage) {
      dsp.garage.add(id);
      return;
    }

    const jsGarage = JSON.parse(localStorage.getItem('garage') || '[]');
    if (!jsGarage.includes(id)) {
      jsGarage.push(id);
    }
    localStorage.setItem('garage', JSON.stringify(jsGarage));
    checkIcon();
  }
}

function comparableCheck() {
  $('.comparable-check').each(function () {
    let comparable = $(this).data('comparable');
    if ($(this).prop('checked')) {
      $(`.${comparable}`).removeClass('hidden');
    } else {
      $(`.${comparable}`).addClass('hidden');
    }
    checkIcon();
  });
}

function comparableFormat() {
  $('.vehicle-garage-card').each(function () {
    // $(this)
    //   .find('.comparable:not(.hidden)')
    //   .each(function (i) {
    //     if (isOdd(i)) {
    //       $(this).find('.compare-info').addClass('text-brand-400');
    //       $(this).find('.compare-info').removeClass('text-brand-500');
    //     } else {
    //       $(this).find('.compare-info').addClass('text-brand-500');
    //       $(this).find('.compare-info').removeClass('text-brand-400');
    //     }
    //   });
      checkIcon();
  });
}

function checkIcon() {
  const $header = $('.js-header-garage').find('.filter-dot');
  if (!LocalGarage.isEmpty()) {
    $header.removeClass('hidden');
  } else {
    $header.addClass('hidden');
  }
}

$(document).on(InventorySearchEvents.GARAGE_UPDATED, checkIcon);

const $garageCover = $('#garage-cover');
if ($garageCover.length) {
  $(document).on(InventorySearchEvents.GARAGE_ITEM_ADD, () => {
    $garageCover.removeClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_ADDED, () => {
    $garageCover.addClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_REMOVE, () => {
    $garageCover.removeClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_ITEM_REMOVED, () => {
    location.reload();
    setTimeout(() => $garageCover.addClass('hidden'), 2000);
  });

  $(document).on(InventorySearchEvents.GARAGE_CLEAR, () => {
    $garageCover.removeClass('hidden');
  });

  $(document).on(InventorySearchEvents.GARAGE_CLEARED, () => {
    location.reload();
    setTimeout(() => $garageCover.addClass('hidden'), 2000);
  });
}

$(document).on(InventorySearchEvents.POST_RENDER, () => {
  LocalGarage.init();
});

LocalGarage.init();
